import React, { useEffect } from "react";
import classNames from "classnames";

import Styles from "./Skeleton.module.scss";

const Skeleton = ({ className, ...props }: React.HTMLProps<HTMLDivElement>) => {
  return <div role={"form"} className={classNames(Styles.skeleton, className)} {...props} />;
};

interface SkeletonContainerProps extends React.HTMLProps<HTMLDivElement> {
  show?: boolean;
  children: JSX.Element;
}

const SkeletonContainer = ({ show, ...props }: SkeletonContainerProps) => {
  const { children, ...other } = props;

  // Fire custom event on mount/update
  useEffect(() => {
    if (!show) {
      // Dispach a custom event
      const customEvent = new CustomEvent("MountEvent", { detail: { component: "Shared - SkeletonContainer" } });
      window.dispatchEvent(customEvent);
    }
  }, [show]);

  return show ? <Skeleton {...other} /> : children;
};

export { Skeleton, SkeletonContainer };
